import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { COMPANY } from "@/lib/company";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Accesso effettuato");
      navigate("/");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2">
      {/* Left branded panel */}
      <div
        className="hidden md:block relative bg-neutral-900 bg-cover bg-center"
        style={{ backgroundImage: `url(https://images.unsplash.com/photo-1622030411594-c282a63aa1bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjB3YXJlaG91c2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODM1ODUwOTV8MA&ixlib=rb-4.1.0&q=85)` }}
      >
        <div className="absolute inset-0 bg-[#002FA7]/85" />
        <div className="relative z-10 h-full p-12 flex flex-col justify-between text-white">
          <div>
            <div className="bg-white px-4 py-3 inline-block">
              <img src={COMPANY.logoUrl} alt="Powercom" className="h-8" />
            </div>
          </div>
          <div>
            <div className="label-eyebrow text-white/70 mb-3">Sistema Gestione Magazzino</div>
            <h2 className="font-display font-black text-5xl tracking-tighter leading-none max-w-md">
              Traccia ogni singolo pezzo.
            </h2>
            <p className="text-white/80 mt-4 max-w-md text-sm">
              Magazzini fisici e furgoni tecnici. Entrate, uscite, resi e trasferimenti con seriali univoci.
            </p>
          </div>
          <div className="text-xs text-white/60 leading-relaxed">
            <div className="font-semibold text-white/80">{COMPANY.name}</div>
            <div>{COMPANY.vat}</div>
            <div className="mt-1">{COMPANY.legal}</div>
            <div>{COMPANY.operational}</div>
          </div>
        </div>
      </div>

      {/* Right form side */}
      <div className="flex items-center justify-center p-8 bg-white">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="md:hidden mb-8">
            <img src={COMPANY.logoUrl} alt="Powercom" className="h-10" />
          </div>
          <div className="label-eyebrow mb-2">Accedi</div>
          <h1 className="font-display font-black text-4xl tracking-tighter mb-1">Bentornato.</h1>
          <p className="text-sm text-neutral-500 mb-8">Inserisci le tue credenziali per continuare.</p>

          <label className="block mb-4">
            <span className="label-eyebrow block mb-2">Email</span>
            <input
              data-testid="login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2.5 border border-neutral-300 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-[#002FA7] focus:border-[#002FA7] transition-colors"
              placeholder="tu@azienda.it"
            />
          </label>

          <label className="block mb-6">
            <span className="label-eyebrow block mb-2">Password</span>
            <input
              data-testid="login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2.5 border border-neutral-300 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-[#002FA7] focus:border-[#002FA7] transition-colors"
              placeholder="••••••••"
            />
          </label>

          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-[#002FA7] hover:bg-[#002480] text-white text-sm font-medium py-3 px-4 transition-colors duration-150 disabled:opacity-50"
          >
            {loading ? "Accesso in corso..." : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
